import { render, staticRenderFns } from "./SubmitProjects.vue?vue&type=template&id=dc52537e&"
import script from "./SubmitProjects.vue?vue&type=script&lang=js&"
export * from "./SubmitProjects.vue?vue&type=script&lang=js&"
import style0 from "./SubmitProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports